var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createRequestPayload, parseQueryParamsString } from './requestPayload';
export var ResponseType;
(function (ResponseType) {
    ResponseType["ArrayBuffer"] = "arraybuffer";
    ResponseType["Blob"] = "blob";
    ResponseType["Document"] = "document";
    ResponseType["JSON"] = "json";
    ResponseType["Text"] = "text";
    ResponseType["Stream"] = "stream";
    ResponseType["Basic"] = "basic";
})(ResponseType || (ResponseType = {}));
export class RestClient {
    constructor({ requester, abortControllersMap, instanceConfig, }) {
        this.createRequestPayload = createRequestPayload;
        this.parseQueryParamsString = parseQueryParamsString;
        this._requester = requester;
        this._abortControllersMap = abortControllersMap;
        this._instanceConfig = instanceConfig;
    }
    get(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._requester.get(props.url, {
                signal: props.signal,
                disableHeaders: props.disableHeaders,
                params: props.params,
                responseType: props.responseType,
                onUploadProgress: props.onUploadProgress,
            });
        });
    }
    // TODO: temporary returned body
    delete(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._requester.delete(props.url, {
                signal: props.signal,
                disableHeaders: props.disableHeaders,
                params: props.params,
                data: props.body,
                onUploadProgress: props.onUploadProgress,
            });
        });
    }
    post(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._requester.post(props.url, props.body, {
                signal: props.signal,
                disableHeaders: props.disableHeaders,
                params: props.params,
                responseType: props.responseType,
                onUploadProgress: props.onUploadProgress,
            });
        });
    }
    patch(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._requester.patch(props.url, props.body, {
                signal: props.signal,
                disableHeaders: props.disableHeaders,
                params: props.params,
                onUploadProgress: props.onUploadProgress,
            });
        });
    }
    put(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._requester.put(props.url, props.body, {
                signal: props.signal,
                disableHeaders: props.disableHeaders,
                params: props.params,
                onUploadProgress: props.onUploadProgress,
            });
        });
    }
    getInstanceConfig() {
        return this._instanceConfig;
    }
    abortAllRequests() {
        for (const abortController of this._abortControllersMap.values()) {
            abortController.abort();
        }
    }
}
